export default __webpack_public_path__ + "appstore-c.png";